var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-line',{attrs:{"data":_vm.chartData,"settings":_vm.chartSettings,"colors":_vm.chartColors,"mark-line":_vm.chartMark,"height":_vm.chartHeight,"width":_vm.chartWidth,"resizeable":true,"theme-name":'dark'}})}
var staticRenderFns = []

export { render, staticRenderFns }